<template>
  <tr v-if="isEditMode">
    <td>
      <v-text-field
        ref="name"
        v-model="name"
        :rules="nameRules"
        counter="255"
        maxlength="255"
        required
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        ref="position"
        v-model="position"
        :rules="positionRules"
        counter="255"
        maxlength="255"
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        ref="phone"
        v-model="phone"
        :rules="phoneRules"
        maxlength="100"
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        ref="email"
        v-model="email"
        :rules="emailRules"
        maxlength="100"
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        ref="comment"
        v-model="comment"
        :rules="commentRules"
        maxlength="1000"
      ></v-text-field>
    </td>
    <td>
      <v-text-field
        ref="externalId"
        v-model="externalId"
        :rules="externalIdRules"
        maxlength="255"
      ></v-text-field>
    </td>
    <td>
      <v-checkbox
        v-model="inviteToDpCases"
      ></v-checkbox>
    </td>
    <td>
      <v-select
        :items="availableSpecialistRole"
        v-model="role"
        item-value="value"
        item-text="name"
        max-height="400"
        persistent-hint
      ></v-select>
    </td>
    <td class="text-right">
      <v-btn flat icon color="green lighten-2" @click="handleSaveButtonClick">
        <v-icon>fas fa-check</v-icon>
      </v-btn>
      <v-btn flat icon color="red lighten-2" class="ml-0" @click="handleEditButtonClick">
        <v-icon>fas fa-times</v-icon>
      </v-btn>
    </td>
  </tr>
  <tr v-else>
    <td>{{ item.name }}</td>
    <td>{{ item.position | NoEmpty}}</td>
    <td>{{ item.phone | NoEmpty}}</td>
    <td>{{ item.email | NoEmpty}}</td>
    <td>{{ item.comment | NoEmpty}}</td>
    <td>{{ item.externalId | NoEmpty}}</td>
    <td>{{ item.inviteToDpCases ? 'Yes' : 'No'}}</td>
    <td>{{ role.name | NoEmpty }}</td>
    <td class="text-right">
      <v-btn flat icon color="black lighten-2" class="mr-0" @click="handleEditButtonClick">
        <v-icon small>fas fa-pencil-alt</v-icon>
      </v-btn>
      <v-btn flat icon color="black lighten-2" class="ml-0" @click="handleDeleteButtonClick">
        <v-icon small>fas fa-trash-alt</v-icon>
      </v-btn>
    </td>
  </tr>
</template>

<script>
import {showApiError} from '../../helpers/notification.js'
import {validateStringLength} from '../../helpers/validation'
import NoEmpty from '../Filters/NoEmpty.js'
import api from '../../api'
import _ from 'lodash'

export default {
  name: 'specialist-item',
  props: {
    item: {
      type: Object
    },
    availableSpecialistRole: {
      type: Array
    }
  },
  filters: {
    NoEmpty
  },
  data () {
    return {
      processing: false,
      validatableRefs: ['name', 'position', 'phone', 'email', 'comment'],
      isEditMode: false,
      draft: {
        id: this.item.id,
        title: this.item.title,
        inviteToDpCases: this.item.inviteToDpCases,
        position: this.item.position,
        phone: this.item.phone,
        email: this.item.email,
        comment: this.item.comment,
        externalId: this.item.externalId,
        role: this.item.role
      },
      nameRules: [
        v => !!v || 'Enter specialist name',
        _.partial(validateStringLength, _, 255, 'The length of the name should be no more than 255 characters')
      ],
      positionRules: [
        _.partial(validateStringLength, _, 300, 'The length of the position should be no more than 255 characters')
      ],
      phoneRules: [
        _.partial(validateStringLength, _, 100, 'The length of the position should be no more than 100 characters')
      ],
      emailRules: [
        _.partial(validateStringLength, _, 100, 'The length of the email should be no more than 100 characters'),
        function (value) {
          if (!value) {
            return true
          }
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      ],
      commentRules: [
        _.partial(validateStringLength, _, 1000, 'The length of the comment should be no more than 1000 characters')
      ],
      externalIdRules: [
        _.partial(validateStringLength, _, 1000, 'The length of the externalId should be no more than 255 characters')
      ]
    }
  },
  beforeCreate () {

  },
  computed: {
    name: {
      get: function () {
        return this.item.name
      },
      set: function (newValue) {
        this.draft.name = newValue
      }
    },
    position: {
      get: function () {
        return this.item.position
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.draft.position = null
        } else {
          this.draft.position = newValue
        }
      }
    },
    phone: {
      get: function () {
        return this.item.phone
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.draft.phone = null
        } else {
          this.draft.phone = newValue
        }
      }
    },
    email: {
      get: function () {
        return this.item.email
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.draft.email = null
        } else {
          this.draft.email = newValue
        }
      }
    },
    comment: {
      get: function () {
        return this.item.comment
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.draft.comment = null
        } else {
          this.draft.comment = newValue
        }
      }
    },
    externalId: {
      get: function () {
        return this.item.externalId
      },
      set: function (newValue) {
        if (newValue.length === 0) {
          this.draft.externalId = null
        } else {
          this.draft.externalId = newValue
        }
      }
    },
    inviteToDpCases: {
      get: function () {
        return this.item.inviteToDpCases
      },
      set: function (newValue) {
        this.draft.inviteToDpCases = newValue
      }
    },
    role: {
      get: function () {
        return _.filter(this.availableSpecialistRole, (i)=>{
          return i.value === this.item.role
        })[0]
      },
      set: function (newValue) {
        this.draft.role = newValue
      }
    }
  },
  watch: {},
  mounted () {
  },
  methods: {
    handleEditButtonClick () {
      this.isEditMode = !this.isEditMode
    },
    handleItemClick () {
      this.$emit('click', this.item)
    },
    async handleSaveButtonClick () {
      if (this.processing) {
        return
      }

      for (let refName of this.validatableRefs) {
        if (!this.$refs[refName].validate(true)) {
          return false
        }
      }

      this.startProcessing()

      try {
        let updatedItem = await api.updateClientSpecialist(this.draft)
        this.isEditMode = false
        this.$emit('updated', updatedItem)
        this.stopProcessing()
      } catch (e) {
        showApiError(this, e, 'Unable to update specialist')
        this.stopProcessing()
      }
    },
    async handleDeleteButtonClick () {
      if (this.processing) {
        return
      }

      if (!confirm('Do you want to remove specialist with name: "' + this.item.name + '"')) {
        return
      }

      this.startProcessing()

      try {
        await api.deleteClientSpecialist(this.item.id)
        this.$emit('deleted', this.item)
        this.stopProcessing()
      } catch (e) {
        showApiError(this, e, 'Unable to delete specialist')
        this.stopProcessing()
      }
    },

    startProcessing () {
      this.processing = true
      this.$emit('startProcessing')
    },
    stopProcessing () {
      this.processing = false
      this.$emit('stopProcessing')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/SpecialistItem.vue